import React from 'react'
import styled, { keyframes } from 'styled-components'
import { usePageIsLoading } from 'hooks/use-page-is-loading'

const PageProgress = () => {
  const loading = usePageIsLoading()

  if (loading) {
    return (
      <Container>
        <ProgressBar />
      </Container>
    )
  }

  return null
}

const progressAnimation = keyframes`
    from {
        transform: translate(-100%, 0);
    }

    to {
        transform: translate(0%, 0);
    }
`

const Container = styled.div`
  background-color: transparent;
  box-sizing: border-box;
  height: 3px;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000;
`

const ProgressBar = styled.span`
  animation: ${progressAnimation} 3s linear infinite;
  background-color: #ffde00;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  transform: translate(-100%, 0);
  width: 100%;
`

export default PageProgress
